module.exports = __webpack_public_path__ + "static/img/A15.56eb0a88.jpg";